// import { useState, useEffect } from "react";

// const BASE_URL = process.env.REACT_APP_BASE_URL;

// const useUniversityProfile = () => {
//   const [isUniversityProfile, setIsUniversityProfile] = useState(false);

//   const fetchCurrentUniversityProfile = async () => {
//     try {
//       const res = await fetch(`${BASE_URL}/marketplace/university/profile`, {
//         method: "GET",
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//           "Content-Type": "application/json",
//           "x-api-key": process.env.REACT_APP_X_API_KEY
//         },
//       });
//       const data = await res.json();
//       console.log(data)
//       setIsUniversityProfile(data.has_profile);
//     } catch (err) {
//       console.error("Error fetching teacher:", err);
//     }
//   };

//   useEffect(() => {
//     fetchCurrentUniversityProfile();
//   }, []);

//   return { isUniversityProfile, fetchCurrentUniversityProfile };
// };

// export default useUniversityProfile;

// hooks/useUniversityProfile.js
// hooks/useUniversityProfile.js
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const useUniversityProfile = () => {
  const navigate = useNavigate();
  const [profileExists, setProfileExists] = useState(false);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await fetch(`${BASE_URL}/marketplace/university/profile`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        });

        const data = await res.json();

        // If profile missing or has_profile is false → redirect
        if (!res.ok || !data || data.has_profile === false) {
          navigate("/marketplace/university/profile");
          setProfileExists(false);
        } else {
          setProfileExists(true);
        }
      } catch (err) {
        console.error(err);
        navigate("/marketplace/university/profile");
        setProfileExists(false);
      }
    };

    fetchProfile();
  }, [navigate]);

  return profileExists; // true if profile exists, false otherwise
};

export default useUniversityProfile;


